import { render, staticRenderFns } from "./vodPoint.vue?vue&type=template&id=367720c2&scoped=true"
import script from "./vodPoint.vue?vue&type=script&lang=js"
export * from "./vodPoint.vue?vue&type=script&lang=js"
import style0 from "./vodPoint.vue?vue&type=style&index=0&id=367720c2&prod&scoped=true&lang=css"
import style1 from "./vodPoint.vue?vue&type=style&index=1&id=367720c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367720c2",
  null
  
)

export default component.exports